import React from "react"
import Tooltip from "../../../components/atoms/Tooltip.atom"
import { ReactComponent as UndoIcon } from "../../../design/assests/images/icons/undo.svg"
import { generateRandomId } from "../../../utils/strings.utils"

const UnifinishHistoricalTask = ({
  loading = false,
  onClick,
  tooltipConfig = {
    position: "left",
    tooltipBody: "Marcar como “Por hacer”",
  },
  iconProps,
  hidden = false,
}) => {
  if (hidden) return null
  const id = generateRandomId()
  const iconClassName = `unfinish-historical-task-icon-${id}`
  return (
    <div className={`${iconClassName} flex`}>
      {loading ?
        <i className="pi pi-spin pi-spinner text-2xl"></i>
      : <UndoIcon
          className={`cursor-pointer clr-text ${iconProps?.className}`}
          onClick={onClick}
          {...iconProps}
        />
      }
      {!loading && (
        <Tooltip
          key={hidden}
          target={`.${iconClassName}`}
          className="unifinish-historical-task-tooltip"
          position={tooltipConfig.position}
        >
          {tooltipConfig.tooltipBody}
        </Tooltip>
      )}
    </div>
  )
}

export default UnifinishHistoricalTask
